module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightTextH"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Grub Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("4 Rainham Close")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Copyright © Grub Street 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Copyright text © Wolfgang Fischer and John Weal 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("British Library Cataloguing in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Fischer, Wolfgang.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Luftwaffe fighter pilot: defending the Reich against the RAF and USAAF.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("1. Fischer, Wolfgang. 2. Germany. Luftwaffe--History.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("3. World War, 1939-1945--Personal narratives, German.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("4. World War, 1939-1945--Aerial operations, German.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("5. Fighter pilots--Germany--Biography.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("I. Title")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("940.5'44943'092-dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ISBN-13: 9781906502836")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("eISBN-13: 978-1-908117-98-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightTextH1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Cover design and typesetting by Sarah Driver")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Edited by Sophie Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Grub Street Publishing only uses")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("FSC (Forest Stewardship Council) paper for its books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5dba036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LuftwaffeFighterPilot_copyright.vue
// module id = 60
// module chunks = 0